import React, { useState } from "react";
import UploadForm from "./UploadForm";
import makeRequest from "../utilities/makeRequest";
import authHeaders from "../utilities/authHeaders";
import notification from "../utilities/notification";

const UploadContainer = ({
  closeModalAfterUpload,
  errors,
  setErrors,
  setLocationMode,
  setNotificationId,
  setPostId,
  setPosts,
  setPreviewImage,
  setPreviewMessage,
  setSelected,
}) => {
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [label, setLabel] = useState("Select a file");
  const [loading, setLoading] = useState(false);
  const [locationError, setLocationError] = useState(false);

  const onChangeImage = (event) => {
    setPreviewMessage(true);
    const imageSize = event.target.files[0].size;
    const maxImageSize = 5 * 1024 * 1024;
    if (imageSize > maxImageSize) {
      alert("File exceeds 5MB limit");
    } else {
      setImage(event.target.value);
      setPreviewImage(URL.createObjectURL(event.target.files[0]));
      setLabel("1 file selected");
    }
  };

  const onChangeDescription = (event) => {
    setDescription(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    const url = `${process.env.REACT_APP_HOST}/api/v1/posts/upload`;
    const method = "POST";
    const fileInput = document.querySelector('input[type="file"]');
    const formData = new FormData();
    formData.append("post[image]", fileInput.files[0], image);
    formData.append("post[description]", description);

    makeRequest(url, method, formData, authHeaders())
      .then((response) => {
        if (response.ok) {
          response.json().then((response) => {
            setLoading(false);
            const newPost = response.data;
            setPosts((posts) => [...posts, newPost]);
            setSelected(newPost);
            closeModalAfterUpload();
            notification("Post created!", "success", 3000);
          });
        } else {
          response.json().then((data) => {
            setPostId(data.post);
            delete data.post;
            setErrors(data);
            if (data.error === "Location not found") {
              setLocationError(true);
            } else {
              setLabel("Select a file");
            }
            setLoading(false);
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleAddLocation = () => {
    setLocationMode(true);
    closeModalAfterUpload();
    const id = notification(
      "Click anywhere on the map to add location",
      "info",
      0
    );
    setNotificationId(id);
  };

  return (
    <UploadForm
      closeModal={closeModalAfterUpload}
      description={description}
      errors={errors}
      handleAddLocation={handleAddLocation}
      handleSubmit={handleSubmit}
      image={image}
      label={label}
      loading={loading}
      locationError={locationError}
      onChangeDescription={onChangeDescription}
      onChangeImage={onChangeImage}
      setErrors={setErrors}
      setPreviewMessage={setPreviewMessage}
    />
  );
};

export default UploadContainer;
